import { createFileRoute } from "@tanstack/react-router";
import { marketingUrl } from "../lib/marketing-url";

export const Route = createFileRoute("/privacy-policy")({
  beforeLoad: () => {
    if (typeof window !== "undefined") {
      window.location.replace(`${marketingUrl}/privacy-policy`);
    }
  },
  component: () => null,
});
